import { useMemo } from 'react';

import { useFormContext } from 'react-hook-form';

import { isDefined } from '@hsp/utilities';

import { useSaveStoreSelector } from 'pages/audience/shared/save/hooks';
import { AudienceOrderType } from 'types/api/audience';
import { SaveForm } from 'types/pages/audience-builder/shared/save';
import { s } from 'utilities/strings';

export const useOrderTypeConfiguration = () => {
  const {
    formState: { errors },
    getValues,
  } = useFormContext<SaveForm>();
  const orderTypeId = getValues('orderTypeId');

  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  const displayValue = useMemo(() => {
    if (isDefined(orderTypeId) && orderTypeId !== AudienceOrderType.NotSet) {
      switch (orderTypeId) {
        case AudienceOrderType.Custom:
          return s('Site.Custom');

        case AudienceOrderType.House:
          return s('Site.House');

        case AudienceOrderType.OnPoint:
          return s('Site.OnPoint');

        case AudienceOrderType.Nls:
          return s('Site.NLS');
      }
    }

    return saveTo ? s(['Site.Select', 'Site.Audience']) : s(['Site.Not', 'Site.Set']);
  }, [orderTypeId, saveTo]);

  return { displayValue, errors };
};
